import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Language } from '../../models/common/language';
import { LanguageSwitcherService } from '../../services/language-switcher.service';
import { KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons';
@Component({
    selector: 'ldm-language-dropdown-selector',
    templateUrl: './language-dropdown-selector.component.html',
    styleUrls: ['./language-dropdown-selector.component.scss'],
    imports: [KENDO_DROPDOWNBUTTON],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageDropdownSelectorComponent {
  shouldBeExtended = input<boolean>(true);

  constructor(public languageSwitcherService: LanguageSwitcherService) {}

  onLanguageChange(language: Language) {
    this.languageSwitcherService.setActiveLanguage(language);
  }
}
